import { Sidebar as ProSidebar } from 'react-pro-sidebar';
import React, { useMemo, useState } from 'react';
import Logo from '@/components/shared/logos/Logo';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import StorageManager from '@/shared/storageManager';
import classNames from 'classnames';
import { envIsSweden } from '@/constants/constants';
import SidebarFooter from '@/components/shared/sidebar/SidebarFooter';
import SidebarNavigation from '@/components/shared/sidebar/SidebarNavigation';
import SidebarUser from '@/components/shared/sidebar/SidebarUser';
import SidebarCashier from '@/components/shared/sidebar/SidebarCashier';
import SmallLogo from '@/components/UI/SmallLogo';

const Sidebar = () => {
  const initialCollapsedString = useMemo(() => StorageManager.getSidebarCollapsed(), []);
  const [collapsed, setCollapsed] = useState(
    initialCollapsedString ? initialCollapsedString === 'true' : true,
  );

  const toggleCollapsed = () => {
    const toggled = !collapsed;
    StorageManager.setSidebarCollapsed(`${toggled}`);
    setCollapsed(toggled);
  };

  return (
    <ProSidebar
      collapsed={collapsed}
      rootStyles={{
        background: 'linear-gradient(0deg, rgba(3,178,203) 0%, rgba(230,252,255,1) 100%)',
      }}
    >
      <div
        className={classNames('h-screen flex flex-col', {
          'pt-[24px]': envIsSweden(),
        })}
      >
        <div className="px-[12px] h-[50px] flex justify-between gap-x-[8px] items-center cursor-pointer">
          {collapsed ? <SmallLogo /> : <Logo />}
          <button
            type="button"
            aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            aria-expanded={!collapsed}
            className="h-[25px] w-[25px] text-blue-medium"
            onClick={toggleCollapsed}
          >
            {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </button>
        </div>

        <div className="flex h-full justify-between flex-col">
          <div>
            <SidebarNavigation />
            <SidebarCashier />
          </div>
          <SidebarUser />
          <SidebarFooter collapsed={collapsed} />
        </div>
      </div>
    </ProSidebar>
  );
};

export default Sidebar;
